import { Theme } from '../theme';
import { ThemeContext } from 'styled-components';
import { assertTheme } from '../util';
import { useContext } from 'react';

export const useTheme = (): Theme => assertTheme(useContext(ThemeContext));
